<label style="color: white">{{ label }}</label>
<div class="dropdown">
  <div class="dropdown-header" (click)="toggleDropdown()">
    <span>{{ placeholder }}</span>
    <span class="static-arrow">
      <mat-icon>
       keyboard_arrow_down
      </mat-icon>
    </span>
  </div>

  <div *ngIf="isDropdownOpen" class="dropdown-list">
    <div *ngFor="let item of items" class="dropdown-item">
      <input
        type="checkbox"
        [checked]="isSelected(item)"
        (change)="onCheckboxChange(item, $event)"
      />
      <label>{{ item }}</label>
    </div>
  </div>
</div>
